<template>
  <div style="overflow-x: hidden;background-color: white;position: absolute;left: 0;right: 0;top: 0" class="bg">
    <Navigator/>
    <SliderBanner :slider="slider"/>
    <Step :stepData="stepInfo" style="background: #F4F7FF"/>
    <FuncShow :funInfo="funInfo" style="background: #F4F7FF"/>
    <Footer/>
    <ContactFloat/>
  </div>
</template>

<script>
import Navigator from '../widgets/navigator'
import Footer from '../widgets/footer'
import SliderBanner from '../widgets/SliderBanner'
import FuncShow from '../widgets/func-show'
import Step from '../widgets/Step'
import ContactFloat from '../widgets/contact-float.vue'
export default {
  components: {
    Navigator,
    FuncShow,
    SliderBanner,
    ContactFloat,
    Step,
    Footer
  },
  data() {
    return {
      stepInfo: {
        title: '订单分佣方案',
        subTitle: '分佣方案可以设置方案模式、方案名称、等级类型、返佣类型、返佣设置、额外补贴和分销补贴等，对不同实体有不同的方案设置，方便不同门店的使用。',
        stepList: [
          {
            normalImg:'',
            choiceImg: '',
            stepTitle: '',
            showImg: require('@/assets/images/index/member-mall/show1.png')
          }
        ]
      },
      slider: {
        image: require('@/assets/images/index/member-mall/phone.png'),
        title: '会员制商城',
        desc: "有抽成设置、分佣方案、订单结算方案、提现制度设置等制度模式"
      },
      funInfo: {
        title: '',
        list: [
          {
            title: '抽成设置',
            img: require('@/assets/images/index/member-mall/img2.png'),
            text: '目前智莺系统可对淘宝联盟、京东联盟、多多进宝、唯品会、多多联盟、考拉赚钱、苏宁易购、饿了么、美团、百果园、喜茶、石化加油、电影票、麦当劳、星巴克、自营商城、多人拼团、区域代理、肯德基、汉堡王、滴滴打车、花小猪、瑞幸咖啡等多种平台的抽成设置'
          },
          {
            title: '订单结算方案',
            img: require('@/assets/images/index/member-mall/img3.png'),
            text: '订单结算方案可以设置方案名称、方案参数、最后更新时间、使用状态等，对不同实体有不同的方案设置，方便不同门店的使用。'
          },
          {
            title: '提现制度设置',
            img: require('@/assets/images/index/member-mall/img4.png'),
            text: '提现制度设置分为用户端和商家端两种提现制度设置，除了用户端有支付宝提现终端设置，其他设置都一样，可以设置提现频率、关闭提现窗口时提示、提现限制 '
          }
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
